// extracted by mini-css-extract-plugin
export default {"root":"N1ReVs","trigger":"sfVlID","ellipsis":"auNrCS","fillCurrentColor":"hxAljV","nav":"urZ5g3","link":"LrXLjZ","itemSticky":"qNIg0P"};